import type { AccountTagEnum } from "@nlc/shared-types";

import { AccountTagIcon } from "../../components/AccountTagIcon";
import { getActiveTagConfigs } from "../../constants/accountTags";

/**
 * Cell renderer for account tags column
 * Displays tag icons with tooltips based on account status
 */
export const accountTagsCell = (
  _value: unknown,
  row: { account?: { id: number; name: string; tags?: AccountTagEnum[] } },
) => {
  const account = row.account;

  // If no account or no tags data, show empty state
  if (!account?.tags) {
    return <span className="text-text-tertiary">--</span>;
  }

  // Get active tag configurations sorted by priority
  const activeTagConfigs = getActiveTagConfigs(account.tags);

  // If no active tags, show empty state
  if (activeTagConfigs.length === 0) {
    return <span className="text-text-tertiary">--</span>;
  }

  // Render tag icons with tooltips
  return (
    <div className="flex gap-2 items-center line-clamp-3 break-words">
      {activeTagConfigs.map((config) => (
        <AccountTagIcon config={config} key={config.type} />
      ))}
    </div>
  );
};
